import { CSSProperties } from "react";

export const calculateDragConstraints = (drawerWidth: number, drawerHeight: number) => {
  // Drawer is positioned at top: 16px, right: 16px by default
  const maxLeft = -(window.innerWidth - drawerWidth - 32);
  const maxBottom = window.innerHeight - drawerHeight - 32;

  // Prevent crossed constraints if drawer is larger than the window
  return {
    left: Math.min(maxLeft, 0),
    right: Math.max(maxLeft, 0),
    top: Math.min(maxBottom, 0),
    bottom: Math.max(maxBottom, 0),
  };
};

export const calculateDrawerStyle = (
  drawerWidth: number,
  drawerHeight: number,
  isOpen: boolean
): CSSProperties => ({
  position: "fixed" as const,
  top: 0,
  right: 0,
  zIndex: 1000000000,
  width: drawerWidth,
  maxWidth: window.innerWidth - 40,
  minWidth: 320,
  height: drawerHeight,
  minHeight: 350,
  maxHeight: window.innerHeight - 40,
  overflow: "hidden" as const,
  display: !isOpen ? "none" : "flex",
  flexDirection: "column" as const,
  background: "#fff",
  boxShadow: "0 10px 15px -3px rgba(0,0,0,0.1), 0 4px 6px -4px rgba(0,0,0,0.1)",
  borderRadius: 12,
  margin: 16,
});
